import { Stack, Box, Heading, Flex, Button } from "@chakra-ui/react";
import StepperComponent from "../../molecule/Stepper/StepperComponent";
import AlertComponent from "../../atom/Alert/AlertComponent";
import { borderRadius, borderStyle } from "../../../utils/styles/styles";
import { useLocation, useNavigate } from "react-router-dom";
import {
  EDIT_ALERT_COMPONENT_DESCRIPTION,
  EDIT_ALERT_COMPONENT_TITLE,
} from "../../../utils/constants";
import { AlertConfig } from "../../../types/Components/Alert/AlertConfig";
import LoadingButton from "../../atom/Button/LoadingButton/LoadingButton";
import AlertDialogComponent from "../../molecule/AlertDialog/AlertDialogComponent";
import { useState } from "react";
import { goBack } from "../../../helpers/goBack";

interface SubmitItemContentProps {
  hasStepper?: boolean;
  steps?: { title: string; description: string }[];
  currentStep?: number;
  formTitle?: string;
  children: React.ReactNode;
  handleDeleteItem?: () => void;
  handleSubmitItem?: () => void;
  deleteButtonName?: string;
  isEditing?: boolean;
  setIsAlertOpen?: (isOpen: boolean) => void;
  isAlertOpen?: boolean | undefined;
  maxWidth?: string;
  hasAlert?: boolean;
  alertConfig?: AlertConfig;
  isLoaded: boolean;
}

const SubmitItemContent: React.FC<SubmitItemContentProps> = ({
  hasStepper,
  steps = [],
  currentStep = 0,
  formTitle,
  children,
  handleDeleteItem,
  handleSubmitItem,
  deleteButtonName,
  isEditing,
  setIsAlertOpen,
  isAlertOpen,
  maxWidth,
  hasAlert = false,
  alertConfig = null,
  isLoaded,
}) => {
  const {
    submitAlertTitle = EDIT_ALERT_COMPONENT_TITLE,
    submitAlertStatus = "info",
    submitAlertDescription = EDIT_ALERT_COMPONENT_DESCRIPTION,
    submitAlertBorderColor = "blue.500",
  } = alertConfig || {};
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const [isUndoDialogOpen, setIsUndoDialogOpen] = useState(false);

  const handleUndoConfirm = () => {
    setIsUndoDialogOpen(false);
    goBack(navigate, pathname);
  };

  return (
    <>
      {hasStepper && (
        <>
          <StepperComponent
            steps={steps}
            currentStep={currentStep}
            maxWidth={maxWidth}
          />
          <Heading as="h4" fontSize="xl">
            {steps[currentStep].description}: {steps[currentStep].title}
          </Heading>
        </>
      )}
      {hasAlert && (
        <Box>
          <AlertComponent
            title={submitAlertTitle}
            status={submitAlertStatus}
            description={submitAlertDescription}
            borderColor={submitAlertBorderColor}
          />
        </Box>
      )}
      <Stack
        spacing={formTitle ? 4 : 6}
        border={formTitle && borderStyle}
        borderRadius={formTitle && borderRadius}
        background={formTitle && "gray.50"}
        p={formTitle && 6}
      >
        {formTitle && (
          <Heading as="h3" fontSize="2xl">
            {formTitle}
          </Heading>
        )}
        {children}
      </Stack>
      <Flex
        direction="row"
        alignItems="flex-end"
        justifyContent="space-between"
        width="100%"
      >
        <Flex gap="4" alignItems="flex-end">
          {handleSubmitItem && isEditing && (
            <>
              <LoadingButton
                variant="primary"
                onClick={handleSubmitItem}
                isLoading={!isLoaded}
              >
                Guardar
              </LoadingButton>
              <Button
                variant="secondary"
                onClick={() => setIsUndoDialogOpen(true)}
              >
                Desfazer alterações
              </Button>
            </>
          )}
        </Flex>

        <Flex justifyContent="flex-end">
          {handleDeleteItem && (
            <LoadingButton
              variant="secondary"
              colorScheme="red"
              onClick={() =>
                setIsAlertOpen ? setIsAlertOpen(true) : handleDeleteItem
              }
              isDisabled={!isEditing}
              isLoading={!isLoaded}
            >
              {deleteButtonName}
            </LoadingButton>
          )}
        </Flex>
      </Flex>
      <AlertDialogComponent
        isOpen={isUndoDialogOpen}
        setIsOpen={setIsUndoDialogOpen}
        title={"Desfazer as alterações"}
        text={"Tem a certeza que pretende desfazer as alteraçõesr?"}
        handleButton={handleUndoConfirm}
        buttonText="Confirmar"
      />
    </>
  );
};

export default SubmitItemContent;
